<article class="notifications">
  <div class="notifications__container container">
    <header class="notifications__header">
      <h4 data-test-id="notificationListHeader" class="t-bold">
        Recent Notifications
      </h4>
    </header>
    @if (notifications.length > 0) {
      <div class="notifications__list">
        @for (notification of notifications; track notification) {
          <notification
            class="notifications__row"
            [attr.data-test-id]="'notificationList_' + notification.id"
            [notification]="notification"
            (readNotification)="setAsRead(notification)"
            (deleteNotification)="deleteNotification(notification)"
          >
          </notification>
        }
      </div>
    } @else {
      @if (config.noNotifications && !loading) {
        <p data-test-id="notificationListEmpty">{{ noNotifications }}</p>
      }
    }
  </div>
</article>

@if (config?.showFooter && !footerConfig?.usesDesignSystem) {
  <zip-footer data-test-id="notificationListFooter"></zip-footer>
}
